import apiClient from "./client";

// Get all users
export function getUsers() {
  return apiClient.get("/teams/users").then((res) => res.data);
}
